import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProfileHeader = ({ influencer, onMessageClick, onProposalClick }) => {
  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="relative h-48 bg-gradient-to-r from-primary/20 to-secondary/20">
        <Image
          src={influencer?.coverImage}
          alt={influencer?.coverImageAlt}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6">
        <div className="flex flex-col md:flex-row gap-6">
          <div className="relative -mt-20 md:-mt-16">
            <div className="w-32 h-32 rounded-full border-4 border-card overflow-hidden bg-muted">
              <Image
                src={influencer?.avatar}
                alt={influencer?.avatarAlt}
                className="w-full h-full object-cover"
              />
            </div>
            {influencer?.verified && (
              <div className="absolute bottom-2 right-2 w-8 h-8 bg-primary rounded-full flex items-center justify-center border-2 border-card">
                <Icon name="CheckCircle" size={20} color="white" />
              </div>
            )}
          </div>

          <div className="flex-1">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
              <div>
                <h1 className="text-2xl font-bold text-foreground">{influencer?.name}</h1>
                <p className="text-muted-foreground mt-1">@{influencer?.username}</p>
                <div className="flex flex-wrap items-center gap-3 mt-3">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-primary/10 text-primary rounded-full text-sm font-medium">
                    <Icon name="Star" size={14} />
                    {influencer?.rating} ({influencer?.reviewCount} değerlendirme)
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-success/10 text-success rounded-full text-sm font-medium">
                    <Icon name="TrendingUp" size={14} />
                    %{influencer?.engagementRate} etkileşim
                  </span>
                </div>
              </div>

              <div className="flex gap-2">
                <Button
                  variant="outline"
                  iconName="MessageSquare"
                  iconPosition="left"
                  onClick={onMessageClick}
                >
                  Mesaj Gönder
                </Button>
                <Button
                  variant="default"
                  iconName="Send"
                  iconPosition="left"
                  onClick={onProposalClick}
                >
                  Teklif Gönder
                </Button>
              </div>
            </div>

            <p className="text-foreground mt-4 leading-relaxed">{influencer?.bio}</p>

            <div className="flex flex-wrap gap-2 mt-4">
              {influencer?.categories?.map((category, index) => (
                <span
                  key={index}
                  className="px-3 py-1 bg-muted text-muted-foreground rounded-md text-sm"
                >
                  {category}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;